<script setup lang="ts">
import { useAppStore } from '../stores/app';

const appStore = useAppStore();

function scrollToTop() {
  appStore.scrollToTop();
}
</script>

<template>
  <transition name="fade-scale">
    <button
      v-if="appStore.showBackToTop"
      class="back-to-top"
      @click="scrollToTop"
      :title="appStore.isZh ? '返回顶部' : 'Back to Top'"
    >
      <div class="btt-flame"></div>
      <div class="btt-ring"></div>
      <i class="fas fa-arrow-up"></i>
    </button>
  </transition>
</template>

<style scoped>
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 52px;
  height: 52px;
  background: var(--nz-gradient-flame);
  border: none;
  border-radius: 50%;
  color: var(--nz-text-bone);
  font-size: var(--nz-text-lg);
  cursor: pointer;
  z-index: var(--nz-z-tooltip);
  box-shadow: var(--nz-glow-flame), var(--nz-shadow-deep);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--nz-t-normal);
  overflow: visible;
  animation: nz-fire-breath 2s ease-in-out infinite;
}

.back-to-top:hover {
  transform: translateY(-5px) scale(1.1);
  box-shadow: 0 0 50px rgba(255, 107, 26, 0.8), var(--nz-shadow-deep);
}

.btt-flame {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 20px;
  background: linear-gradient(to top, var(--nz-flame-mid), var(--nz-gold-solid));
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  filter: blur(4px);
  opacity: 0.9;
  animation: bttFlame 0.4s ease-in-out infinite;
}

.btt-ring {
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  border: 1px solid var(--nz-glass-border-bright);
  opacity: 0.5;
  animation: nz-pulse-ring 2s ease-out infinite;
  pointer-events: none;
}

@keyframes bttFlame {
  0%, 100% {
    transform: translateX(-50%) scale(1);
    height: 20px;
  }
  50% {
    transform: translateX(-50%) scale(1.15);
    height: 26px;
  }
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s var(--nz-ease-bounce);
}

.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.8) translateY(20px);
}

@media (max-width: 768px) {
  .back-to-top {
    bottom: 20px;
    right: 20px;
    width: 46px;
    height: 46px;
    font-size: var(--nz-text-base);
  }
}
</style>
